import React, { useContext } from "react";
import css from "../Modulecss/Home.module.css";
import { Link } from "react-router-dom";
import Header from "../Components/Header";
import { LanguageContext } from "../Components/LanguageContext";
import { useTheme } from "../../ThemeContext";
import { colors } from "@mui/material";

export default function RunningCard({ runnig, winnAmount, game_type }) {
  const user = localStorage.getItem("userId");
  // console.log(user,"running")

  // language
  const translations = {
    hi: {
      view: "देखे",
      prize: "इनाम",
      entry: "प्रवेश शुल्क",
    },
    en: {
      view: "View",
      entry: "Entry Fee ",
      prize: "Winning Prize",
    },
  };

  const { language } = useContext(LanguageContext);

  // change theme
  const theme  = localStorage.getItem('theme')

  const styles = {
    color: theme === "light" ? "black" : "black",
  };

  return (
    <>
      <div className={`${css.compactBattleCard} ${css.runningCard} mt-1`}>
        <div className="d-flex align-items-center justify-content-between p-2">
          <div className="d-flex align-items-center">
            <img src={runnig?.Created_by?.avatar ? process.env.REACT_APP_BACKEND_LIVE_API + runnig.Created_by.avatar : "/images/avatars/Avatar1.png"} alt="" className={css.smallAvatar} />
            <span className={`${css.compactName} ml-2`}>{runnig.Created_by?.Name?.length > 8 ? `${runnig.Created_by?.Name.slice(0,8)}...` : runnig.Created_by?.Name}</span>
          </div>

          <div className={css.vsCenter}>
            <span className={css.vsIcon}></span>
          </div>

          <div className="d-flex align-items-center">
            <span className={`${css.compactName} mr-2`}>{runnig.Accepetd_By?.Name?.length > 8 ? `${runnig.Accepetd_By?.Name.slice(0,8)}...` : runnig.Accepetd_By?.Name}</span>
            <img src={runnig?.Accepetd_By?.avatar ? process.env.REACT_APP_BACKEND_LIVE_API + runnig.Accepetd_By.avatar : "/images/avatars/Avatar1.png"} alt="" className={css.smallAvatar} />
          </div>
        </div>

        <div className="text-center pb-2">
          <div className={css.compactAmount}>Rs {runnig?.Game_Ammount}</div>
        </div>

        {/* Center Action (View Button or VS Icon) */}
                  <div className="stat-center-action" style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                    {user == runnig.Accepetd_By._id || user == runnig.Created_by._id ? (
                      <Link
                        className={`view-game-btn ${runnig.Status === "conflict" ? "status-conflict" : "status-success"}`}
                        to={{
                          pathname: `/viewgame1/${runnig._id}`,
                          state: { prevPath: window.location.pathname },
                        }}
                        
                      >
                        {translations[language].view}
                      </Link>
                    ) : null}
                  </div>
      </div>
    </>
  );
}
